import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=499e5e58&"
import script from "./ru.vue?vue&type=script&lang=js&"
export * from "./ru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports